module.exports = __webpack_public_path__ + "img/sm-想吃甜點是不需要理由的.85814c0d.svg";